import React from 'react';


//components
import Navbar from '../_components/common/Navbar/index';
import Footer from '../_components/common/Footer/index';

import { Link } from 'react-router-dom';

import './404page.css';

export default function page404(props) {
const userType = localStorage.getItem('usertype');
const isAdmin = userType.includes('super_admin') || userType.includes('seller_admin') || userType.includes('organisation_admin')
  return (
    <div>
        <div id="notfound" className="animation-fade-in">
            <div className="notfound">
                {
                    props.unauthorised ?
                        <div>
                            <div className="notfound-404">
                                <div className="rotate360Anim data_div">
                                    <a href="https://www.freeiconspng.com/img/34312" title="Image from freeiconspng.com">
                                        {/* <img className="rotateGearAnim" src="https://www.freeiconspng.com/uploads/gear-icon-9.png" width="350" alt="Download Png Gear Icons" /> */}
                                    </a>
                                </div>
                                <h1 style={{display: 'flex'}}>401</h1>
                            </div>
                            <p>You are not authorised to view this content. Would you like to go to the Homepage instead?</p>
                            <Link className="btn btn-primary" to={isAdmin ? '/admin/app/dashboard' : '/app/dashboard'}>Take me Back</Link>
                        </div>
                    :
                        <div>
                            <div className="notfound-404">
                                <div className="rotate360Anim data_div">
                                    <a href="https://www.freeiconspng.com/img/34312" title="Image from freeiconspng.com">
                                        {/* <img className="rotateGearAnim" src="https://www.freeiconspng.com/uploads/gear-icon-9.png" width="350" alt="Download Png Gear Icons" /> */}
                                    </a>
                                </div>
                                <h1 style={{display: 'flex'}}>404</h1>
                            </div>
                            <h2>Page not found</h2>
                            <p>Looks like you have landed wrong. Would you like to go to the Homepage instead?</p>
                            <Link className="btn btn-primary" to={isAdmin ? '/admin/app/dashboard' : '/app/dashboard'}>Take me Back</Link>
                        </div>
                }
                {/* <a href="#">home page</a> */}
            </div>
        </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/_pages/404page.js